const redAcuteToxicitiesHazards = new Set(['H300', 'H310', 'H330']);

const rules = [
  {
    description: 'Extreme acute toxicity',
    info: { highOrExtreme: true },
    matcher: {
      hazards: ['H300', 'H310', 'H330'],
    },
    masses: [
      {
        lessThan: 0.001,
        score: 3,
      },
      {
        lessThan: 0.003,
        score: 6,
      },
      {
        lessThan: +Infinity,
        score: 12,
      },
    ],
  },
  {
    description: 'High acute toxicity',
    info: { highOrExtreme: true },
    matcher: {
      hazards: ['H311', 'H318', 'H331'],
    },
    masses: [
      {
        lessThan: 0.001,
        score: 2,
      },
      {
        lessThan: 0.003,
        score: 3,
      },
      {
        lessThan: +Infinity,
        score: 4,
      },
    ],
  },
  {
    description: 'Medium acute toxicity',
    info: { highOrExtreme: false },
    matcher: {
      hazards: [
        'H302',
        'H303',
        'H305',
        'H312',
        'H313',
        'H330',
        'H332',
        'H333',
        'H334',
      ],
    },
    masses: [
      {
        lessThan: 0.001,
        score: 1,
      },
      {
        lessThan: 0.003,
        score: 2,
      },
      {
        lessThan: +Infinity,
        score: 3,
      },
    ],
  },
  {
    description: 'Low acute toxicity',
    info: { highOrExtreme: false },
    matcher: {
      hazards: [
        'H301',
        'H304',
        'H315',
        'H316',
        'H317',
        'H319,H320',
        'H334',
        'H335',
        'H336',
      ],
    },
    masses: [
      {
        lessThan: 0.001,
        score: 0.5,
      },
      {
        lessThan: 0.003,
        score: 1,
      },
      {
        lessThan: +Infinity,
        score: 2,
      },
    ],
  },
  {
    description: 'No known acute toxicity',
    info: { highOrExtreme: false },
    matcher: {},
    masses: [
      {
        lessThan: +Infinity,
        score: 0,
      },
    ],
  },
];

export function appendAcuteToxicity(reagents, report, options) {
  const { logger } = options;
  let redAcuteToxicities = new Set();
  // what is the worse hazard ?
  for (const rule of rules) {
    for (const reagent of reagents) {
      if (reagent.safety.acuteToxicity) continue;

      appendRed(reagent, redAcuteToxicities);
      const matching = isMatching(reagent, rule);
      if (!matching) continue;
      reagent.safety.acuteToxicity = {
        description: rule.description,
        matchingHazards: matching.matchingHazards || [],
        info: rule.info,
        score: rule.masses.find((mass) => reagent.mass.value <= mass.lessThan)
          .score,
      };
    }
  }

  /*
  If high or extreme are present only take sum of high and extreme values.
  If no high or extreme, simply take the score for the one reagent that leads to the highest score.
  */
  const highOrExtremes = reagents.filter(
    (reagent) => reagent.safety.acuteToxicity.info.highOrExtreme,
  );
  if (highOrExtremes.length === 0) {
    logger?.info(
      'AcuteToxicity: No high or extreme acute toxicity. Taking the highest score of the other.',
    );
    report.scores.acuteToxicity = Math.max(
      ...reagents.map((reagent) => reagent.safety.acuteToxicity.score),
    );
  } else {
    logger?.info(
      'AcuteToxicity: High or extreme acute toxicity. Taking the sum of them.',
    );
    report.scores.acuteToxicity = highOrExtremes.reduce(
      (sum, reagent) => sum + reagent.safety.acuteToxicity.score,
      0,
    );
  }
  report.redAcuteToxicity = [...redAcuteToxicities];
}

function isMatching(reagent, rule) {
  if (!rule.matcher.hazards) return true;
  const matchingHazards = rule.matcher.hazards.filter((hazard) =>
    reagent.hazards.includes(hazard),
  );
  if (matchingHazards.length === 0) return false;
  return {
    matchingHazards,
  };
}

function appendRed(reagent, redAcuteToxicities) {
  for (const hazard of reagent.hazards) {
    if (redAcuteToxicitiesHazards.has(hazard)) {
      redAcuteToxicities.add(hazard);
    }
  }
}
